// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5a5a5364","473":"fda2d9c4","509":"6f0556d8","977":"c24fa8e5"}[chunkId] + ".chunk.js";
};